module.exports = __webpack_public_path__ + "img/tnc.3dc82437.svg";